// features/bank/bankSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios';


interface BankState {
  linkToken: string | null;
  accounts: any[];
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: BankState = {
  linkToken: null,
  accounts: [],
  loading: false,
  error: null,
  success: null
};

export const createLinkToken = createAsyncThunk<{linkToken: string | null; expiration:string | null, requestId: string | null}>(
  'bank/createLinkToken',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.post('api/services/app/Banking/CreateLinkToken');
      
      return response.data.result;
    } catch (err) {
      if (err instanceof Error && (err as any).response && (err as any).response.data) {
        return rejectWithValue((err as any).response.data);
      }
      return rejectWithValue('An unknown error occurred');
    }
  }
);

export const exchangePublicToken = createAsyncThunk(
  'bank/exchangePublicToken',
  async (publicToken: string, { rejectWithValue }) => {
    try {
      const response = await axios.post('api/services/app/Banking/ExchangePublicToken', {
        publicToken
      });
      return response.data.result;
    } catch (err) {
      if (
        typeof err === 'object' &&
        err !== null &&
        'response' in err &&
        typeof (err as any).response === 'object' &&
        (err as any).response !== null &&
        'data' in (err as any).response
      ) {
        return rejectWithValue((err as any).response.data);
      }
      return rejectWithValue('An unknown error occurred');
    }
  }
);

const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLinkToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(createLinkToken.fulfilled, (state, action) => {
        console.log('Link token created:', action.payload);
        state.linkToken = action.payload.linkToken;
        state.loading = false;
      })
      .addCase(createLinkToken.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      })
      .addCase(exchangePublicToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(exchangePublicToken.fulfilled, (state, action) => {
        state.accounts = action.payload.accounts;
        state.success = 'Bank account linked successfully!';
        state.loading = false;
      })
      .addCase(exchangePublicToken.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  }
});

export const { clearMessages } = bankSlice.actions;
export default bankSlice.reducer;